import { render } from "./CompeteEnterprise.vue?vue&type=template&id=4b2f65fa&scoped=true"
import script from "./CompeteEnterprise.vue?vue&type=script&lang=js"
export * from "./CompeteEnterprise.vue?vue&type=script&lang=js"

import "./CompeteEnterprise.vue?vue&type=style&index=0&id=4b2f65fa&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2f65fa"]])

export default __exports__